<template>
    <div class="s-nice-text">
        <header>
            <h2>
                <topic-title :isLink="false" :topic="topic"></topic-title>
            </h2>
        </header>

        <p class="u-margin-bottom" v-html="topic.introLong.replace(/\n/g, '<br>')"></p>

        <div v-if="topic.profiles.length">
            <h3 class="u-margin-bottom-tiny">연사</h3>
            <ul>
                <li v-for="profile of topic.profiles">
                    <router-link :to="`/profile/${profile.id}`">
                        {{ profile.name }}
                        <small class="u-text-tiny">{{ profile.introShort }}</small>
                    </router-link>
                </li>
            </ul>
        </div>

        <h3 class="u-margin-bottom-tiny">이 토론이 속한 주제</h3>
        <ul>
            <li v-for="category of topic.directlyBelongingCategories">
                <span v-for="c of category.path">
                    <router-link :to="`/topic-category/${c.id}`">{{ c.name }}</router-link>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Topic",
        props: ["topic", 'marxism'],
        data: () => {
            return {
                history: window.history
            }
        },
        methods: {},
        mounted() {
            let pageTitle = this.topic.title;
            if (this.topic.subtitleTop) {
                pageTitle = `${this.topic.subtitleTop}: ${pageTitle}`;
            }
            if (this.topic.subtitleBottom) {
                pageTitle = `${pageTitle} — ${this.topic.subtitleBottom}`;
            }
            document.querySelector('title').innerText = `${pageTitle} | ${marxism.title} - 마르크스주의 포럼`;

            if (window.gtag) {
                // for google analytics page tracking
                window.gtag('config', 'UA-2193909-1', {
                    'page_title': `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`,
                    'page_path': (new URL(location.href)).pathname
                });
            }
        }
    }
</script>

<style scoped>

</style>
